import React from "react";

const Java_cos = () => {
  return (
    <div>
      <h1>Java cos</h1>
      <p>This page provides explanations, examples, and common use-cases for Java cos in Java.</p>
    </div>
  );
};

export default Java_cos;
